var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "chats-counter__counter-group" }, [
    _c("i", {
      staticClass:
        "fal fa-comment chats-counter__counter-icon chats-counter__counter-icon_comments",
      class: { "new-only": _vm.onlyNewMessages },
    }),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass: "chats-counter__counter",
        class: { "new-only": _vm.onlyNewMessages },
      },
      [_vm._v(_vm._s(_vm.totalMessagesCount))]
    ),
    _vm._v(" "),
    _vm.unreadMessagesCount && !_vm.onlyNewMessages
      ? _c("span", { staticClass: "chats-counter__new-counter" }, [
          _vm._v("(+" + _vm._s(_vm.unreadMessagesCount) + ")"),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }